export default function SpeedFlame({ vitesse }) {
  const config = {
    1: { flames: 1, bg: 'bg-blue-500/20' },
    2: { flames: 2, bg: 'bg-orange-500/20' },
    3: { flames: 3, bg: 'bg-red-500/20' },
  }
  const { flames, bg } = config[vitesse] ?? config[1]
  return (
    <div className={`flex items-center gap-1 px-3 py-1.5 rounded-full ${bg}`}>
      {[...'🔥'.repeat(flames)].map((f, i) => (
        <span key={i} className="text-2xl leading-none">{f}</span>
      ))}
    </div>
  )
}
